import moment from 'moment'

const STORAGE_KEY = 'mock_utility_contracts_v1'

export const CONTRACT_STATUS = Object.freeze({
  DRAFT: 'draft',
  SIGNED: 'signed',
  ACTIVE: 'active',
  EXPIRING: 'expiring',
  EXPIRED: 'expired',
})

export const CONTRACT_STATUS_OPTIONS = [
  {
    value: CONTRACT_STATUS.DRAFT,
    label: 'Đang soạn thảo',
    color: 'default',
  },
  {
    value: CONTRACT_STATUS.SIGNED,
    label: 'Đã ký',
    color: 'blue',
  },
  {
    value: CONTRACT_STATUS.ACTIVE,
    label: 'Đang hiệu lực',
    color: 'green',
  },
  {
    value: CONTRACT_STATUS.EXPIRING,
    label: 'Sắp hết hạn',
    color: 'gold',
  },
  {
    value: CONTRACT_STATUS.EXPIRED,
    label: 'Hết hiệu lực',
    color: 'red',
  },
]

export const CONTRACT_STATUS_MAP = CONTRACT_STATUS_OPTIONS.reduce(
  (accumulator, option) => {
    accumulator[option.value] = option
    return accumulator
  },
  {}
)

export const SERVICE_TYPE_OPTIONS = [
  'Dịch vụ Hosting',
  'Dịch vụ Domain',
  'Dịch vụ Cloud Server',
  'Dịch vụ Bảo trì',
  'Dịch vụ Email doanh nghiệp',
]

const DEFAULT_CONTRACTS = [
  {
    id: 'contract-100045',
    contractNo: 'HĐ-2026-00045',
    supplierName: 'Công ty TNHH Dịch vụ ABC',
    customerName: 'Công ty TNHH XYZ',
    signedDate: '2026-03-31',
    effectiveDate: '2026-04-01',
    status: CONTRACT_STATUS.ACTIVE,
    description:
      'Hợp đồng cung cấp nhiều gói dịch vụ với thời gian hiệu lực riêng biệt theo từng loại dịch vụ.',
    totalValue: 58350000,
    services: [
      {
        id: 'service-001',
        serviceType: 'Dịch vụ Hosting',
        value: 12500000,
        startDate: '2026-04-01',
        endDate: '2027-03-31',
        note: 'Hiệu lực 12 tháng, tự động gia hạn',
      },
      {
        id: 'service-002',
        serviceType: 'Dịch vụ Domain',
        value: 850000,
        startDate: '2026-04-01',
        endDate: '2026-09-30',
        note: 'Hiệu lực 6 tháng',
      },
      {
        id: 'service-003',
        serviceType: 'Dịch vụ Cloud Server',
        value: 45000000,
        startDate: '2026-05-15',
        endDate: '2028-05-14',
        note: 'Hiệu lực 24 tháng',
      },
    ],
    documents: [
      {
        id: 'doc-0001',
        name: 'Hop_dong_00045.pdf',
        size: 2145210,
        uploadedAt: '2026-03-31',
      },
      {
        id: 'doc-0002',
        name: 'Phu_luc_hop_dong_00045.docx',
        size: 945210,
        uploadedAt: '2026-03-31',
      },
      {
        id: 'doc-0003',
        name: 'Bao_gia_dich_vu_00045.xlsx',
        size: 652210,
        uploadedAt: '2026-03-30',
      },
      {
        id: 'doc-0004',
        name: 'Bien_ban_nghiem_thu_00045.pdf',
        size: 175210,
        uploadedAt: '2026-03-30',
      },
    ],
    createdAt: '2026-03-31 08:30:00',
    updatedAt: '2026-03-31 08:30:00',
  },
  {
    id: 'contract-100044',
    contractNo: 'HĐ-2026-00044',
    supplierName: 'Công ty TNHH Dịch vụ ABC',
    customerName: 'Công ty CP Phát triển ABC',
    signedDate: '2026-03-15',
    effectiveDate: '2026-03-20',
    status: CONTRACT_STATUS.SIGNED,
    description: 'Hợp đồng cung cấp dịch vụ Hosting và Domain.',
    totalValue: 12850000,
    services: [
      {
        id: 'service-004',
        serviceType: 'Dịch vụ Hosting',
        value: 12000000,
        startDate: '2026-03-20',
        endDate: '2027-03-19',
        note: 'Gói Hosting tiêu chuẩn',
      },
      {
        id: 'service-005',
        serviceType: 'Dịch vụ Domain',
        value: 850000,
        startDate: '2026-03-20',
        endDate: '2027-03-19',
        note: 'Tên miền .com',
      },
    ],
    documents: [
      {
        id: 'doc-0005',
        name: 'Hop_dong_00044.pdf',
        size: 1825210,
        uploadedAt: '2026-03-15',
      },
      {
        id: 'doc-0006',
        name: 'Phu_luc_hop_dong_00044.pdf',
        size: 645210,
        uploadedAt: '2026-03-15',
      },
    ],
    createdAt: '2026-03-15 10:02:00',
    updatedAt: '2026-03-20 08:16:00',
  },
  {
    id: 'contract-100043',
    contractNo: 'HĐ-2026-00043',
    supplierName: 'Công ty TNHH Dịch vụ ABC',
    customerName: 'Công ty TNHH Thương mại Minh Châu',
    signedDate: '2026-02-01',
    effectiveDate: '2026-02-05',
    status: CONTRACT_STATUS.EXPIRING,
    description: 'Hợp đồng nhiều dịch vụ với điều khoản gia hạn theo từng gói.',
    totalValue: 125000000,
    services: [
      {
        id: 'service-006',
        serviceType: 'Dịch vụ Hosting',
        value: 25000000,
        startDate: '2026-02-05',
        endDate: '2027-02-04',
        note: 'Gói Enterprise',
      },
      {
        id: 'service-007',
        serviceType: 'Dịch vụ Domain',
        value: 3000000,
        startDate: '2026-02-05',
        endDate: '2027-02-04',
        note: '05 tên miền quốc tế',
      },
      {
        id: 'service-008',
        serviceType: 'Dịch vụ Cloud Server',
        value: 90000000,
        startDate: '2026-02-05',
        endDate: '2027-02-04',
        note: 'Cụm máy chủ dự phòng',
      },
      {
        id: 'service-009',
        serviceType: 'Dịch vụ Bảo trì',
        value: 7000000,
        startDate: '2026-02-05',
        endDate: '2027-02-04',
        note: 'Bảo trì định kỳ hàng quý',
      },
    ],
    documents: [
      {
        id: 'doc-0007',
        name: 'Hop_dong_00043.pdf',
        size: 1965210,
        uploadedAt: '2026-02-01',
      },
      {
        id: 'doc-0008',
        name: 'Bao_gia_00043.xlsx',
        size: 822110,
        uploadedAt: '2026-02-01',
      },
      {
        id: 'doc-0009',
        name: 'Mau_nghiem_thu_00043.docx',
        size: 725210,
        uploadedAt: '2026-02-01',
      },
    ],
    createdAt: '2026-02-01 14:20:00',
    updatedAt: '2026-03-18 09:10:00',
  },
]

const isBrowser = typeof window !== 'undefined'

const cloneData = data => JSON.parse(JSON.stringify(data))

const generateId = prefix => {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
}

const saveContracts = contracts => {
  if (!isBrowser) return
  localStorage.setItem(STORAGE_KEY, JSON.stringify(contracts))
}

const loadContracts = () => {
  const fallbackData = cloneData(DEFAULT_CONTRACTS)

  if (!isBrowser) {
    return fallbackData
  }

  try {
    const rawValue = localStorage.getItem(STORAGE_KEY)
    if (!rawValue) {
      saveContracts(fallbackData)
      return fallbackData
    }

    const parsed = JSON.parse(rawValue)
    if (Array.isArray(parsed)) {
      return parsed
    }
  } catch (error) {
    console.error('Không thể đọc dữ liệu hợp đồng mock', error)
  }

  saveContracts(fallbackData)
  return fallbackData
}

export const formatCurrencyVN = value => {
  return `${Number(value || 0).toLocaleString('vi-VN')} ₫`
}

export const getMockContracts = () => {
  const contracts = loadContracts()
  return contracts.sort((left, right) => {
    return new Date(right.signedDate) - new Date(left.signedDate)
  })
}

export const getMockContractById = contractId => {
  const contracts = loadContracts()
  return contracts.find(contract => String(contract.id) === String(contractId))
}

export const generateNextContractNo = () => {
  const contracts = loadContracts()
  const currentYear = moment().year()

  const sequenceList = contracts
    .map(contract => {
      const matched = String(contract.contractNo || '').match(/HĐ-(\d{4})-(\d+)/)
      if (!matched) return null
      const year = Number(matched[1])
      const sequence = Number(matched[2])
      if (year !== currentYear || Number.isNaN(sequence)) return null
      return sequence
    })
    .filter(sequence => Number.isInteger(sequence))

  const nextSequence = (Math.max(...sequenceList, 0) || 0) + 1
  return `HĐ-${currentYear}-${String(nextSequence).padStart(5, '0')}`
}

export const createMockContract = payload => {
  const contracts = loadContracts()
  const now = moment().format('YYYY-MM-DD HH:mm:ss')

  const newContract = {
    ...payload,
    id: generateId('contract'),
    createdAt: now,
    updatedAt: now,
  }

  contracts.unshift(newContract)
  saveContracts(contracts)
  return newContract
}

export const updateMockContract = (contractId, payload) => {
  const contracts = loadContracts()
  const contractIndex = contracts.findIndex(
    contract => String(contract.id) === String(contractId)
  )

  if (contractIndex < 0) return null

  const updatedContract = {
    ...contracts[contractIndex],
    ...payload,
    id: contracts[contractIndex].id,
    updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
  }

  contracts.splice(contractIndex, 1, updatedContract)
  saveContracts(contracts)
  return updatedContract
}

export const deleteMockContract = contractId => {
  const contracts = loadContracts()
  const nextContracts = contracts.filter(
    contract => String(contract.id) !== String(contractId)
  )
  saveContracts(nextContracts)
  return nextContracts
}
